<template>
  <v-flex>
    {{ description }}
    <!--
    <read-more
      v-responsive.xl
      more-str="ˇ"
      :text="description"
      link="#"
      less-str="ˆ"
      :max-chars="500"></read-more>
    <read-more
      v-responsive.lg
      more-str="ˇ"
      :text="description"
      link="#"
      less-str="ˆ"
      :max-chars="400"></read-more>
    <read-more
      v-responsive.md
      more-str="ˇ"
      :text="description"
      link="#"
      less-str="ˆ"
      :max-chars="400"></read-more>
    <read-more
      v-responsive.sm
      more-str="ˇ"
      :text="description"
      link="#"
      less-str="ˆ"
      :max-chars="200"></read-more>
    <read-more
      v-responsive.xs
      more-str="ˇ"
      :text="description"
      link="#"
      less-str="ˆ"
      :max-chars="100"></read-more>
    -->
  </v-flex>
</template>
<script>
import vueResponsive from 'vue-responsive'

function fallbackCopyTextToClipboard(text) {
  var textArea = document.createElement("textarea");
  textArea.value = text;
  
  // Avoid scrolling to bottom
  textArea.style.top = "0";
  textArea.style.left = "0";
  textArea.style.position = "fixed";

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    var successful = document.execCommand('copy');
    var msg = successful ? 'successful' : 'unsuccessful';
    console.log('Fallback: Copying text command was ' + msg);
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err);
  }

  document.body.removeChild(textArea);
}
function copyTextToClipboard(text) {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text);
    return;
  }
  navigator.clipboard.writeText(text).then(function() {
    console.log('Async: Copying to clipboard was successful!');
  }, function(err) {
    console.error('Async: Could not copy text: ', err);
  });
}


export default {
  data: () => ({
    snackbar: false,
  }),
  props: {
    description: {
      type: String,
      required: true
    },
    item: {
      type: Object
    }
  },
  directives: {
    responsive: vueResponsive
  },
  computed: {
  },
  methods: {
  }
}
</script>
<style>
.share-btn {
  text-decoration: none;
  padding-right: 20px;
}
  [data-responsives] span {
    position: relative;
    display: block;
  }
  [data-responsives] span a:first-child {
    position: absolute;
    bottom: 0;
    width: 100%;
    text-align: center;
    box-shadow: 0px -18px 18px black;
    text-decoration: none;
    color: white;
    border-top: 1px solid rgba(200,200,200, 0.1);
    height: 20px;
    font-family: monospace;
    font-size: xx-large;
    font-weight: bold;
    cursor: pointer;
  }
  [data-responsives] span a:nth-child(2) {
    position: absolute;
    bottom: 0;
    width: 100%;
    text-align: center;
    /*box-shadow: 0px -18px 18px white;*/
    text-decoration: none;
    color: white;
    border-top: 1px solid rgba(200,200,200, 0.1);
    height: 20px;
    font-family: monospace;
    font-size: xx-large;
    font-weight: bold;
    cursor: pointer;
  }
</style>
